import { useState, useCallback } from 'react';
import '../../utils/assertions.es.js';
import { callAllHandlers } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const useDisclosure = (props = {}) => {
  const { defaultIsOpen = false, onOpen: onOpenProp, onClose: onCloseProp } = props;
  const [isOpen, setIsOpen] = useState(defaultIsOpen);
  const onOpen = useCallback(() => {
    setIsOpen(true);
    onOpenProp == null ? void 0 : onOpenProp();
  }, [onOpenProp]);
  const onClose = useCallback(() => {
    setIsOpen(false);
    onCloseProp == null ? void 0 : onCloseProp();
  }, [onCloseProp]);
  const onToggle = useCallback(() => {
    isOpen ? onClose() : onOpen();
  }, [isOpen, onClose, onOpen]);
  const getTriggerProps = useCallback((props2 = {}) => __spreadProps(__spreadValues({}, props2), {
    "aria-expanded": isOpen,
    onClick: callAllHandlers(props2.onClick, onOpen)
  }), [isOpen, onOpen]);
  const getDisclosureProps = (props2 = {}) => __spreadValues({}, props2);
  return { isOpen, onOpen, onClose, onToggle, getTriggerProps, getDisclosureProps };
};

export { useDisclosure };
//# sourceMappingURL=useDisclosure.es.js.map
